import useSWR from "swr";
import { getTemplateApis } from "../services/template-service";
import type { TemplateApisResponse, TemplateApiItem } from "../types/api-types";

export interface UseTemplateApisReturn {
  templateApis: TemplateApiItem[] | undefined;
  isLoading: boolean;
  // SWR returns any, so a more explicit type cannot be used
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  mutate: () => void;
}

const useTemplateApis = (templateId: number | null): UseTemplateApisReturn => {
  const { data, error, isLoading, mutate } = useSWR<TemplateApisResponse>(
    templateId ? `template-apis-${templateId}` : null,
    () =>
      templateId
        ? getTemplateApis(templateId)
        : Promise.resolve({ results: [] }),
  );

  return {
    templateApis: data?.results,
    isLoading,
    error,
    mutate,
  };
};

export default useTemplateApis;
